var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClass,attrs:{"type":_vm.type},on:{"click":_vm.click,"mousedown":function($event){return _vm.$emit('mousedown')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }